export * from './header';
export * from './footer';
export * from './image-slider';
export * from './game-item';
export * from './profile-update-form';
export * from './group-game-item';
export * from './loader';
export * from './side-bar';
export * from './pop-in-text';
export * from './password-update-form';
export * from './transaction-update-form';
export * from './game-history-form';


// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/index.ts